import React, {useEffect, useState} from 'react'
import {Card, CardContent} from "semantic-ui-react";
import Input from "../input/Input";
import Dropdown from "../input/Dropdown";
import Grid from "../Grid";
import {StatusCellStyle} from "../renderer/StyleRenderer";
import {getBulkDropdownData, getFieldValuesByTableAndId} from "../../api/keyvalue";
import SelectRenderer from "../renderer/SelectRenderer";
import Button from "../input/Button";
import {FORMS, MODULES} from "../../const";
import {Mail, Printer, User} from "react-feather";
import {downloadDocumentDeliveryNote, generateAndSendEmail, updateDDNByID} from "../../api/documentDeliveryNoteApi";
import {useSelector} from "react-redux";
import {toast} from "react-toastify";
import {formatFromJsonDate} from "../../dateConfig";
import InfoList from "../InfoList";
import LoadingSpinner from "../LoadingSpinner";

function DocumentDeliveryNoteDrawer({resultSet, onClose}) {
    const user = useSelector((state => state.user));
    const [isLoading, setIsLoading] = useState(false);

    const [attentionPerson, setAttentionPerson] = useState("");
    const [email, setEmail] = useState("");
    const [description, setDescription] = useState("");
    const [status, setStatus] = useState(1);
    const [active, setActive] = useState(1);

    const [statusOptions, setStatusOptions] = useState([]);
    const [ddnStatusOptions, setDdnStatusOptions] = useState([]);
    const [activeOptions, setActiveOptions] = useState([]);

    const [gridData, setGridData] = useState([]);

    useEffect(() => {
        (async () => {
            setIsLoading(true);

            const {
                status: statusData,
                active: activeData,
                ddn_status: ddnStatusData
            } = await getBulkDropdownData([
                {key: "ddn_status"},
                {key: "status"},
                {key: "active"}

            ]);

            setStatusOptions(statusData);
            setDdnStatusOptions(ddnStatusData);
            setActiveOptions(activeData);
            setIsLoading(false);
        })();
    },[]);

    // Extract logic to a separate async function
    const fetchDetailResponses = async (detailRows) => {
        return await Promise.all(
            detailRows.map(async (row) => {
                let invoiceCode = "";
                let invCustomer = "";
                let evInv = row.ddndDocumentType === 1
                    ? "Invoice"
                    : row.ddndDocumentType === 2
                        ? "EV"
                        : row.ddndDocumentType === 3
                            ? "Credit Note"
                            : row.ddndDocumentType === 4
                                ? "Debit Note"
                                : "";
                if (row.ddndDocumentId) {
                    let response;
                    console.log("Result Set: ",resultSet);
                    if (row.ddndDocumentType === 1 || row.ddndDocumentType === 2) {
                        response = await getFieldValuesByTableAndId({
                            tableName: "finance.tms_f_job_ev_invoices_header",
                            primaryKey: "eih_id",
                            fieldNames: "eih_code, eih_inv_customer",
                            ids: row.ddndDocumentId.toString(),
                        });
                    }else{
                        response = await getFieldValuesByTableAndId({
                            tableName: "finance.tms_f_job_creditdebit_header",
                            primaryKey: "dcr_id",
                            fieldNames: "dcr_code, dcr_inv_customer",
                            ids: row.ddndDocumentId.toString(),
                        });
                    }
                    if (response && response.length > 0) {
                        invoiceCode = response[0].field1 || "";
                        invCustomer = response[0].field2 || "";
                    }
                }
                return {
                    ...row,
                    invoiceCode,
                    invCustomer,
                    evInv,
                };
            })
        );
    };

    useEffect(() => {
        setIsLoading(true);
        setGridData(resultSet.documentDeliveryNoteDetailResponses);
        setAttentionPerson(resultSet.ddnAttentionPerson);
        setEmail(resultSet.ddnEmail);
        setDescription(resultSet.ddnDescription);
        setStatus(resultSet.ddnStatus);
        setActive(resultSet.ddnActive);

        if (resultSet && resultSet.documentDeliveryNoteDetailResponses) {
            fetchDetailResponses(resultSet.documentDeliveryNoteDetailResponses).then(setGridData);
        }
        setIsLoading(false);
    }, [resultSet]);

    const handleSubmit = async() => {
        const payload = {
            ddnAttentionPerson: attentionPerson,
            ddnEmail: email,
            ddnDescription: description,
            ddnTotal: resultSet.ddnTotal,
            ddnStatus: status,
            ddnActive: active,
            createdBy: resultSet.createdBy,
            deliveryNoteDetailRequests: gridData.map((detail) => ({
                ddndId: detail.ddndId,
                ddndHeader: resultSet.ddnId,
                ddndDocumentType: detail.ddndDocumentType,
                ddndInvoiceAmount: detail.ddndInvoiceAmount,
                ddndDocumentId: detail.ddndDocumentId,
                ddndStatus: detail.ddndStatus,
                ddndActive: detail.ddndActive,
                createdBy: user.username,
            })),
        };
        try{
            const response = await updateDDNByID(resultSet.ddnId,payload );
            if(response.status === 200){
                toast.success("Updated Successfully", {
                    autoClose: 5000,
                    containerId: "Main",});
                onClose();
            }
        }catch (e) {
            console.log(e);
        }
    }

    // Define the handlePrint function
    const handlePrint = async() => {
        setIsLoading(true);
        const payload = {
            ddnNo: resultSet.ddnCode,
            date: new Date(resultSet.createdDate).toLocaleString(),
            customer: resultSet.customerName || "N/A",
            address: resultSet.invCustAddress,
            attention: resultSet.ddnAttentionPerson,
            type: resultSet.documentDeliveryNoteDetailResponses?.[0]?.ddndDocumentType,
            createdBy: resultSet.createdBy,
            invoices: resultSet.documentDeliveryNoteDetailResponses.map((item) => ({
                      date: new Date(item.createdDate).toLocaleString(),
                      number: (resultSet.invoiceCodes || "")
                      .split(",")
                      .map(code => code.trim())[
                      (resultSet.invoiceIds || "").split(",").map(id => id.trim()).findIndex(id => Number(id) === Number(item.ddndDocumentId))
                       ] || item.ddndCode,
                      amount: `${item.ddndInvoiceAmount.toFixed(2)}`
                 }))
        };
        try{
            const response = await downloadDocumentDeliveryNote(payload);
            if (response) {
                const blob = new Blob([response], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Document_Delivery_Note_${resultSet.ddnCode}.pdf`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }catch (e) {
            console.log(e);
            setIsLoading(false);
        }
        setIsLoading(false);
    }

    const handleEmail = async () => {
        setIsLoading(true);
        const payload = {
            ddnNo: resultSet.ddnCode,
            date: new Date(resultSet.createdDate).toLocaleString(),
            customer: resultSet.customerName || "N/A",
            address: resultSet.invCustAddress,
            attention: resultSet.ddnAttentionPerson,
            createdBy: resultSet.createdBy,
            invoices: resultSet.documentDeliveryNoteDetailResponses.map((item) => ({
                date: new Date(item.createdDate).toLocaleString(),
                number: (resultSet.invoiceCodes || "")
                    .split(",")
                    .map(code => code.trim())
                    .find(code => code.endsWith(item.ddndDocumentId?.toString())) || item.ddndCode,
                amount: `${item.ddndInvoiceAmount.toFixed(2)}`
            }))
        };
        try {
            const response = await generateAndSendEmail(resultSet.ddnId, payload);
            if (response && response.status === 200) {
                toast.success("Email sent successfully", {
                    autoClose: 5000,
                    containerId: "Main",
                });
            }
        } catch (e) {
            console.log(e);
            setIsLoading(false);
        }
        setIsLoading(false);
    };

    return (
       <>
           { isLoading ? (
               <LoadingSpinner/>
              ) : (
               <Card style={{width: "100%", height: "95%"}}>
                   <CardContent style={{width: "100%", height: "100%"}}>
                       <form className="ui form">
                           <div className="ui segment">
                               <h4 className="ui dividing header">Delivery Note</h4>
                               <div className="three fields">
                                   <Input
                                       label={"DDN Code"}
                                       value={resultSet.ddnCode}
                                       disabled={true}
                                   />
                                   <Input
                                       label={"Attention Person"}
                                       value={attentionPerson}
                                       onChange={(e) => {
                                           setAttentionPerson(e.target.value)
                                       }}
                                   />
                                   <Input
                                       label={"Email"}
                                       value={email}
                                       onChange={(e) => {
                                           setEmail(e.target.value)
                                       }}
                                   />
                               </div>
                               <div className="one field">
                                   <Input
                                       label={"Description"}
                                       value={description}
                                       onChange={(e) => {
                                           setDescription(e.target.value)
                                       }}
                                   />
                               </div>
                               <div className="three fields">
                                   <Input
                                       label={"Total"}
                                       value={Number(resultSet.ddnTotal).toFixed(2)}
                                       disabled={true}
                                   />
                                   <Dropdown
                                       label={"Status"}
                                       options={statusOptions}
                                       value={status}
                                       onChange={(e, data) => {
                                           const newStatus = data.value;
                                           setStatus(newStatus);
                                           if (newStatus === 2) {
                                               setGridData((prevGridData) =>
                                                   prevGridData.map((row) =>
                                                       row.ddndStatus !== 2 ? { ...row, ddndStatus: 2 } : row
                                                   )
                                               );
                                           }
                                       }}
                                   />
                                   <Dropdown
                                       label={"Active"}
                                       options={activeOptions}
                                       value={active}
                                       onChange={(e, data) => {
                                           setActive(data.value)
                                       }}
                                   />
                               </div>
                           </div>

                           {/*  Document Delivery Note Details  */}
                           <div className="ui segment">
                               <h4 className="ui dividing header">Invoice Details</h4>
                               <Grid
                                   content={gridData}
                                   config={[
                                       {headerName: "Code", field: "ddndCode"},
                                       {headerName: "Invoice Code", field: "invoiceCode"},
                                       {headerName: "Document Type", field: "evInv"},
                                       {
                                           headerName: "Amount",
                                           field: "ddndInvoiceAmount",
                                           cellStyle: {textAlign: "right", justifyContent: "right"},
                                           valueFormatter: (params) => Number(params.value).toFixed(2),
                                       },
                                       {
                                           headerName: "Status",
                                           field: "ddndStatus",
                                           cellRenderer: SelectRenderer,
                                           cellRendererParams: (params) => {
                                               return {
                                                   value: params.data.ddndStatus,
                                                   options: ddnStatusOptions,
                                                   onChangeHandler: (data) => {

                                                       setGridData((prevGridData) => {
                                                           const newData = prevGridData.map((row) => {
                                                               if (row.ddndId === params.data.ddndId) {
                                                                   const updatedRow = { ...row, ddndStatus: data };
                                                                   return updatedRow;
                                                               }
                                                               return row;
                                                           });
                                                           if (newData.every((row) => row.ddndStatus === "2")) {
                                                               setStatus(2);
                                                           }
                                                           return newData;
                                                       });
                                                   }
                                               };
                                           }
                                       },
                                       {headerName: "Created By", field: "createdBy"}
                                   ]}
                               />
                           </div>
                           <div className="ui segment">
                               <InfoList
                                   title="User Information"
                                   content={[
                                       {
                                           title: "Created By",
                                           value: resultSet.createdBy ? resultSet.createdBy : "N/A",
                                       },
                                       {
                                           title: "Created Date",
                                           value: resultSet.createdDate
                                               ? formatFromJsonDate(resultSet.createdDate)
                                               : "N/A",
                                       },
                                       {
                                           title: "Last Modified By",
                                           value: resultSet.lastModifiedBy
                                               ? resultSet.lastModifiedBy
                                               : "N/A",
                                       },
                                       {
                                           title: "Last Modified Date",
                                           value: resultSet.lastModifiedDate
                                               ? formatFromJsonDate(resultSet.lastModifiedDate)
                                               : "N/A",
                                       },
                                   ]}
                                   Icon={User}
                               />
                           </div>
                       </form>
                       <div
                           style={{
                               width: "100%",
                               display: "flex",
                               alignItems: "center",
                               justifyContent: "flex-end",
                               padding: "1rem",
                           }}
                       >
                           <div style={{display: "flex", alignItems: "center"}}>
                               <Button
                                   type="button"
                                   template="custom"
                                   className="ui orange button"
                                   label="Email"
                                   Icon={Mail}
                                   onClick={handleEmail}
                               />
                               <Button
                                   type="button"
                                   template="custom"
                                   className="ui green button"
                                   label="Print"
                                   Icon={Printer}
                                   onClick={handlePrint}
                               />
                               <Button template={"create"} create={false} onClick={handleSubmit}/>
                           </div>
                       </div>
                   </CardContent>
               </Card>
           )}
       </>
    )
}

export default DocumentDeliveryNoteDrawer
